export const accessType = {
  GET_INVITE_USERS_LIST: "GET_INVITE_USERS_LIST",
  ACCOUNT_HISTORY_LIST: "ACCOUNT_HISTORY_LIST",
  ACCOUNT_VOICES_LIST: "ACCOUNT_VOICES_LIST",
};
